export default "/provide-liquidity.e2e44c591d762762050314ad8f1ba030.svg";